import { render } from "./DashboardSourceMedium.vue?vue&type=template&id=3f18a39c"
import script from "./DashboardSourceMedium.vue?vue&type=script&lang=js"
export * from "./DashboardSourceMedium.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__